import { render } from "./InputEstoque.vue?vue&type=template&id=5c340bdc&scoped=true"
import script from "./InputEstoque.vue?vue&type=script&lang=js"
export * from "./InputEstoque.vue?vue&type=script&lang=js"

import "./InputEstoque.vue?vue&type=style&index=0&id=5c340bdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c340bdc"]])

export default __exports__